export default [
    {
        id: 1,
        name_ca: "Nom, NIF i adreça del sol·licitant",
        name_es: "Nombre, NIF y dirección del solicitante",
        name_en: "Petitioner details: Name, tax identification number, ID and address"
    },
    {
        id: 2,
        name_ca: "Nom, NIF i adreça fiscal per a la factura",
        name_es: "Nombre, NIF y dirección fiscal para la factura",
        name_en: "Invoice details: Name, tax identification number and fiscal address"
    },
    {
        id: 3,
        name_ca: "Còpia completa de l'escriptura o de la nota registral",
        name_es: "Copia completa de la escritura o de la nota registral",
        name_en: "Full copy of the property deed or registration note"
    },
    {
        id: 4,
        name_ca: "Còpia de rebut de l'I.B.I. (Dades Cadastrals) (Opcional)",
        name_es: "Copia de recibo del I.B.I. (Datos Cadastrales) (Opcional)",
        name_en: "Property tax payment receipt copy (Cadastral data) (Optional)"
    },
    {
        id: 5,
        name_ca: "Plànol de la finca (Opcional)",
        name_es: "Plano de la finca (Opcional)",
        name_en: "Plan of the property (Optional)"
    },
    {
        id: 6,
        name_ca: "Còpia del contracte de lloguer i un rebut actualitzat (en el cas d'estar llogat)",
        name_es: "Copia del contrato de alquiler y un recibo actualizado (en el caso de estar alquilado)",
        name_en: "Full copy of the rental contract and an updated receipt (in the event of being rented)"
    },
    {
        id: 7,
        name_ca: "Finalitat de la taxació (adquisició o venda, constituir garanties hipotecàries, expropiació,...)",
        name_es: "Finalidad de la tasación (adquisición o venta, constituir garantías hipotecarias, expropiación... )",
        name_en: "Valuation purpose (Acquisition or sale, to provide mortgage guarantees, expropiation...)"
    },
    {
        id: 8,
        name_ca: "Nom i telèfon de la persona de contacte per a visitar la finca",
        name_es: "Nombre y teléfono de la persona de contacto para visitar la finca",
        name_en: "Name and telephone number of the contact person in order to visit the property"
    },
    {
        id: 9,
        name_ca: "Còpia del projecte visat pel Col·legi d'Arquitectes",
        name_es: "Copia del proyecto visado por el Colegio de Arquitectos",
        name_en: "Copy of the project validated by the Architects Professional Association"
    },
    {
        id: 10,
        name_ca: "Llicència d'obres, contracte d'execució d'obres i pressupost de contracte d'obra",
        name_es: "Licencia de obras, contrato de ejecución de obras y presupuesto de contrato de obra",
        name_en: "Construction license, construction contract and construction budget"
    },
    {
        id: 11,
        name_ca: "En el cas d'ésser Habitatge de Protecció Oficial: cèdula de qualificació provisional",
        name_es: "En el caso de ser Vivienda de Protección Oficial: cédula de calificación provisional",
        name_en: "In the case of being a Subsidized Dwelling: provisional qualification card"
    },
    {
        id: 12,
        name_ca: "Document acreditatiu de l'assegurança decennal",
        name_es: "Documento acreditativo del seguro decenal",
        name_en: "Decennial insurance proving document"
    },
    {
        id: 13,
        name_ca: "Darrera certificació d'obra executada",
        name_es: "Última certificación de obra ejecutada",
        name_en: "Last certification of executed construction"
    },
    {
        id: 14,
        name_ca: "Cèdul·la urbanística o certificat municipal de qualificació urbanística",
        name_es: "Cédula urbanística o certificado municipal de calificación urbanística",
        name_en: "Certificate of urban planning qualification"
    }
]



// WEBPACK FOOTER //
// ./src/options/requireddocs.js